import { reducer as addressReducer } from './addressSlice';
import { reducer as countryReducer } from './countrySlice';

export const mainAddressReducer = {
  address: addressReducer,
  country: countryReducer,
};
